// extracted by mini-css-extract-plugin
export default {"plusIcon":"AddItemModal_plusIcon__Y3VDN","plusIconDiv":"AddItemModal_plusIconDiv__TAssd","modalScrollableBody":"AddItemModal_modalScrollableBody__LSvdw"};